import { useRef } from 'react'
import { useDrag, useDrop } from 'react-dnd'

import css from './sass/adminitem.module.scss'
import { getImageUrl } from '../util/images'
import dragIcon from './images/drag-handle.svg'
import { AUCTION_ITEM, FIXED_PRICE_ITEM } from './itemorderutils'

const ITEM_ORDER_ROW = 'ITEM_ORDER_ROW'

const ITEM_TYPE_LABELS = {
  [AUCTION_ITEM]: 'Auction Item',
  [FIXED_PRICE_ITEM]: 'Fixed Item',
}

export default function ItemOrderArrangeRow({ auctionCode, index, item, itemType, moveItem }) {
  const rowRef = useRef(null)
  const imageUrl = getImageUrl(auctionCode, item.ItemCode, item.ImageFilename)

  const [{ handlerId }, drop] = useDrop({
    accept: ITEM_ORDER_ROW,
    collect: (monitor) => ({
      handlerId: monitor.getHandlerId(),
    }),
    hover: (draggedItem, monitor) => {
      if (!rowRef.current || draggedItem.index === index) return

      const rowBounds = rowRef.current.getBoundingClientRect()
      const rowMiddleY = (rowBounds.bottom - rowBounds.top) / 2
      const pointerPosition = monitor.getClientOffset()

      if (!pointerPosition) return

      const pointerY = pointerPosition.y - rowBounds.top

      if (draggedItem.index < index && pointerY < rowMiddleY) return
      if (draggedItem.index > index && pointerY > rowMiddleY) return

      moveItem(draggedItem.index, index)
      draggedItem.index = index
    },
  })

  const [{ isDragging }, drag] = useDrag({
    type: ITEM_ORDER_ROW,
    item: () => ({ index }),
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })

  drag(drop(rowRef))

  return (
    <li
      ref={rowRef}
      className={`${css['item-order-arrange-row']} ${isDragging ? css['item-order-arrange-row-dragging'] : ''}`}
      data-handler-id={handlerId}
    >
      <img
        className={css['item-order-icon']}
        src={dragIcon}
        alt={`Drag ${item.Title}`}
        draggable={false}
      />
      <img
        className={css['item-order-thumbnail']}
        src={imageUrl}
        alt={`${item.Title} thumbnail`}
        draggable={false}
      />
      <span className={css['item-order-title']}>{item.Title}</span>
      <span>{item.Category || 'N/A'}</span>
      <span>{ITEM_TYPE_LABELS[itemType]}</span>
    </li>
  )
}
